import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5.145 1.93.91 9a1 1 0 0 0 .855 1.5h8.47A1 1 0 0 0 11.09 9L6.855 1.93a1 1 0 0 0-1.71 0M6 4.5v2M6 8.5h.005"
    }, null, -1)
  ])))
}
export default { render: render }